import Vue from 'vue'
import Vuex from 'vuex'
import Auth from './modules/Auth'
import A0001Admin from '@/components/functions/A0001Admin/A0001AdminStore'
import C0002Customers from '@/components/functions/C0002Customers/C0002CustomersStore'
import M0501Mailer from '@/components/functions/M0501Mailer/M0501MailerStore'
import M0601Survey from '@/components/functions/M0601Survey/M0601SurveyStore'
import M0601SurveyForm from '@/components/functions/M0601SurveyForm/M0601SurveyFormStore'
import M0611SurveySubmission from '@/components/functions/M0611SurveySubmission/M0611SurveySubmissionStore'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    Auth,
    A0001Admin,
    C0002Customers,
    M0501Mailer,
    M0601Survey,
    M0601SurveyForm,
    M0611SurveySubmission
  }
})
